import { getLiveDatabaseSizeMetrics } from './database-size/live-database-size-metrics';
import { type SelectionsAnalyticsAttributes } from './types';

/**
 * Returns common analytics attributes for selection events.
 *
 * Usage: spread into the event data at each call site:
 * ```ts
 * analyticsClient.sendSomeEvent({
 *   ...getSelectionsAnalyticsAttributes(contentId),
 *   contentId,
 *   ...
 * });
 * ```
 */
export function getSelectionsAnalyticsAttributes(
  contentId: string
): SelectionsAnalyticsAttributes {
  const metrics = getLiveDatabaseSizeMetrics(contentId);

  return {
    databaseEntryCount: metrics?.entriesCount,
    databaseFieldCount: metrics?.fieldsCount,
  };
}
